// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/header.css';
import reanimeitorBanner from '../Assets/reanimeitor-banner-removebg-preview.png';
import supporticon from '../Assets/soporte.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('userToken');
      const user = localStorage.getItem('userData');

      if (token && user) {
        setIsLoggedIn(true);
        setUserData(JSON.parse(user));
      } else {
        setIsLoggedIn(false);
        setUserData(null);
      }
    };

    checkAuthStatus();

    const handleStorageChange = () => {
      checkAuthStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('authChange', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authChange', handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');

    setIsLoggedIn(false);
    setUserData(null);
    setIsMenuOpen(false);

    navigate('/');
  };

  const handleMobileLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" className="logo-link">
            <img
              src={reanimeitorBanner}
              alt="Reanimeitor"
              className="logo-image"
            />
          </Link>
        </div>

        <nav className="nav-desktop">
          <Link to="/" className="nav-link">Inicio</Link>
          <a href="https://reanimeitor.com/blog/tienda/" className="nav-link">Tienda</a>
          <Link to="/about" className="nav-link">Nosotros</Link>
          <a href="/blog" className="nav-link">Blog</a>
          <a href="/blog/codigo-rasca/" className="nav-link">Rasca y Gana</a>
        </nav>

        <div className="user-actions">
          <a href="/soporte" className="support-icon" aria-label="Soporte">
            <img
              src={supporticon}
              alt="Soporte"
              className="support-image"
            />
          </a>

          <div className="desktop-menu">
            {isLoggedIn ? (
              <div className="user-menu">
                <Link to="/account" className="nav-link account-link">
                  👤
                  {userData?.name && (
                    <span className="user-name">({userData.name})</span>
                  )}
                </Link>

                {window.location.pathname === '/account' && (
                  <button
                    onClick={handleLogout}
                    className="logout-btn"
                  >
                    Cerrar Sesión
                  </button>
                )}
              </div>
            ) : (
              <Link to="/register" className="login-btn">Únete</Link>
            )}
          </div>

          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menú"
          >
            ☰
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav className="nav-mobile">
          <Link to="/" className="nav-link" onClick={handleMobileLinkClick}>Inicio</Link>
          <a href="https://reanimeitor.com/blog/tienda/" className="nav-link" onClick={handleMobileLinkClick}>Tienda</a>
          <Link to="/about" className="nav-link" onClick={handleMobileLinkClick}>Nosotros</Link>
          <a href="/blog" className="nav-link" onClick={handleMobileLinkClick}>Blog</a>
          <a href="/blog/codigo-rasca/" className="nav-link" onClick={handleMobileLinkClick}>Rasca y Gana</a>

          {isLoggedIn ? (
            <>
              <Link to="/account" className="nav-link" onClick={handleMobileLinkClick}>
                👤 Mi Cuenta
              </Link>

              {window.location.pathname === '/account' && (
                <button
                  onClick={() => {
                    handleLogout();
                    handleMobileLinkClick();
                  }}
                  className="nav-link logout-btn-mobile"
                >
                  🚪 Cerrar Sesión
                </button>
              )}
            </>
          ) : (
            <Link to="/register" className="nav-link" onClick={handleMobileLinkClick}>Únete</Link>
          )}
        </nav>
      )}
    </header>
  );
};

export default Header;